<template>
  <div id="com-content" class="com-con" style="margin-top: 105px">
    <div class="wrapper">
      <div id="un-lobby" class="clearfix" style="padding-top: 45px">
        <aside>
          <ul id="reg-aside" class="sidebar">
            <li class="pt">
              <a href="javascript:void(0);" @click="$parent.goNav('/joker')"
                ><span
                  ><font style="vertical-align: inherit"
                    ><font style="vertical-align: inherit">{{ $t('header.boardgame') }}</font></font
                  ></span
                ></a
              >
            </li>
            <li class="live">
              <a href="javascript:void(0);" @click="$parent.goNav('/realbet')"
                ><span
                  ><font style="vertical-align: inherit"
                    ><font style="vertical-align: inherit">{{ $t('header.livevideo') }}</font></font
                  ></span
                ></a
              >
            </li>
            <li class="sport">
              <a href="javascript:void(0);" @click="$parent.goNav('/sport')"
                ><span
                  ><font style="vertical-align: inherit"
                    ><font style="vertical-align: inherit">{{ $t('header.sportingevents') }}</font></font
                  ></span
                ></a
              >
            </li>
            <li class="lottery">
              <a href="javascript:void(0);" @click="$parent.goNav('/lottery')"
                ><span
                  ><font style="vertical-align: inherit"
                    ><font style="vertical-align: inherit">{{ $t('header.lotterybetting') }}</font></font
                  ></span
                ></a
              >
            </li>
            <li class="sl">
              <a href="javascript:void(0);" @click="$parent.goNav('/concise')"
                ><span
                  ><font style="vertical-align: inherit"
                    ><font style="vertical-align: inherit">{{ $t('header.electronicgames') }}</font></font
                  ></span
                ></a
              >
            </li>
          </ul>
        </aside>
        <article id="articles">
          <div class="logo_register" style="position: relative; left: -39px">
            <h3 class="register-title">
              <font style="vertical-align: inherit"
                ><font style="vertical-align: inherit">{{ $store.state.appInfo.title }}{{ $t('register.registerWelcome') }}</font></font
              >
            </h3>
            <div style="font-size: 14px; width: auto; text-indent: 34px; box-sizing: border-box; padding-left: 60px">
              <p>
                <font style="vertical-align: inherit"
                  ><font style="vertical-align: inherit">{{ $t('register.joinin') }}{{ $store.state.appInfo.title }}{{ $t('register.Entertainment') }}</font></font
                >
              </p>
              <p>
                <font style="vertical-align: inherit"
                  ><font style="vertical-align: inherit">{{ $t('register.maximum1') }}</font></font
                >
              </p>
              <p>
                <font style="vertical-align: inherit"
                  ><font style="vertical-align: inherit">{{ $t('register.maximum2') }}</font></font
                >
              </p>
              <p>
                <font style="vertical-align: inherit"
                  ><font style="vertical-align: inherit">{{ $t('register.maximum3') }}</font></font
                >
              </p>
              <p>
                <font style="vertical-align: inherit"
                  ><font style="vertical-align: inherit">{{ $t('register.maximum4') }}</font
                  ><font style="vertical-align: inherit">{{ $t('register.maximum5') }}</font></font
                >
              </p>
            </div>
          </div>

          <div class="yo-register yo-sm-reg" id="registerMemberYoReg">
            <div class="yo-reg-center">
              <div class="yo-r-main">
                <form action="http://mb1.tg-demo.cc:86/registerDo" method="post">
                  <input type="hidden" name="_token" value="Bgg0a6xeQEfi4MIRSrHietU0kxZUNQGdfrD28TP9" />
                  <fieldset>
                    <legend class="r-zhzc">
                      <font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit">{{ $t('register.Signup') }}</font></font
                      >
                    </legend>
                    <div class="yo-rbox-cen">
                      <div class="reg-box">
                        <span class="joinus-label"
                          ><span class="red-sign"
                            ><font style="vertical-align: inherit"><font style="vertical-align: inherit">*</font></font></span
                          ><font style="vertical-align: inherit"
                            ><font style="vertical-align: inherit">{{ $t('register.account') }}</font></font
                          ></span
                        >
                        <input v-model="registerInfo.name" class="joinus-input" type="text" name="name" id="name" maxlength="32" :placeholder="$t('register.number')" />
                      </div>
                      <div class="reg-box">
                        <span class="joinus-label"
                          ><span class="red-sign"
                            ><font style="vertical-align: inherit"><font style="vertical-align: inherit">*</font></font></span
                          ><font style="vertical-align: inherit"
                            ><font style="vertical-align: inherit">{{ $t('register.password') }}</font></font
                          ></span
                        >
                        <div class="yo-pass-box">
                          <input v-model="registerInfo.password" class="joinus-input" type="password" name="password" id="password" autoComplete="new-password" maxlength="16" :placeholder="$t('register.minimumPassword')" />
                          <a class="yo-mm-yc" href="javascript:;"></a>
                        </div>
                      </div>
                      <div class="reg-box">
                        <span class="joinus-label"
                          ><span class="red-sign"
                            ><font style="vertical-align: inherit"><font style="vertical-align: inherit">*</font></font></span
                          ><font style="vertical-align: inherit"
                            ><font style="vertical-align: inherit">{{ $t('register.Confirm') }}</font></font
                          ></span
                        >
                        <div class="yo-pass-box">
                          <input class="joinus-input" v-model="registerInfo.confirmPass" type="password" name="repassword" id="repassword" value="" autoComplete="new-password" maxlength="16" :placeholder="$t('register.confirmconfirm')" />
                          <a class="yo-mm-yc" href="javascript:;"></a>
                        </div>
                        <!-- <p class="y-warn-msg t-tipmsg"></p> -->
                      </div>
                    </div>
                  </fieldset>
                  <fieldset>
                    <legend class="r-hyzl">
                      <font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit">{{ $t('register.Member') }}</font></font
                      >
                    </legend>
                    <div class="yo-rbox-cen">
                      <div class="reg-box">
                        <span class="joinus-label">
                          <span class="red-sign"
                            ><font style="vertical-align: inherit"><font style="vertical-align: inherit">*</font></font></span
                          ><font style="vertical-align: inherit"
                            ><font style="vertical-align: inherit">{{ $t('register.actual') }} </font></font
                          ></span
                        >
                        <!-- onkeyup="value=value.replace(/[^\u4e00-\u9fa50-9a-zA-Z~!@#$%^&amp;*()_+,.?|:{};=-]/ig, '')" -->
                        <input class="joinus-input" v-model="registerInfo.realname" type="text" name="realname" id="realname" maxlength="32" :placeholder="$t('register.real')" />
                        <!-- <p class="y-warn-msg t-tipmsg">
                          <font style="vertical-align: inherit"><font style="vertical-align: inherit">必须与您的银行账户名相同，否则无法入金！</font></font>
                        </p> -->
                      </div>
                      <div class="reg-box">
                        <span class="joinus-label">
                          <span class="red-sign"
                            ><font style="vertical-align: inherit"><font style="vertical-align: inherit">*</font></font></span
                          ><font style="vertical-align: inherit"
                            ><font style="vertical-align: inherit">{{ $t('register.Withdrawals') }} </font></font
                          ></span
                        >
                        <div class="yo-pass-box">
                          <input type="password" autocomplete="new-password" v-model="registerInfo.paypassword" class="joinus-input" name="qukuanmima" :placeholder="$t('register.withdrawal')" maxlength="6" oninput="value=value.replace(/[^0-9]/g,'')" />
                        </div>
                        <!-- <p class="y-warn-msg t-tipmsg">
                          <font style="vertical-align: inherit"><font style="vertical-align: inherit">取款时使用的密码很重要，请记住！</font></font>
                        </p> -->
                      </div>
                      <div class="reg-box">
                        <span class="joinus-label">
                          <span class="red-sign"
                            ><font style="vertical-align: inherit"><font style="vertical-align: inherit">*</font></font></span
                          ><font style="vertical-align: inherit"
                            ><font style="vertical-align: inherit">{{ $t('register.code') }}</font
                            >&nbsp;</font
                          ></span
                        >
                        <input class="joinus-input" style="width: 151px" v-model="registerInfo.code" type="text" maxlength="4" :placeholder="$t('register.verification')" />
                        <img style="cursor: pointer; height: 42px" :src="`/static/image/yzm/${imgLis[index]}.png`" @click="changIndex" alt="" />
                      </div>
                    </div>
                  </fieldset>
                  <fieldset>
                    <div class="yo-rbox-cen">
                      <div class="reg-box yo-agreement">
                        <span class="joinus-label" style="width: 40px">
                          <input type="checkbox" name="agree" id="check1" checked="checked" v-model="check_agree" />
                        </span>
                        <h6>
                          <font style="vertical-align: inherit"
                            ><font style="vertical-align: inherit"> {{ $t('register.confirmthat') }}</font></font
                          ><a class="yo-c-link yo-tkxy" href="javascript:;" @click="$parent.goNav('/footAll?type=4')"
                            ><font style="vertical-align: inherit"
                              ><font style="vertical-align: inherit">{{ $t('register.Agreement') }}</font></font
                            ></a
                          ><font style="vertical-align: inherit"><font style="vertical-align: inherit">。</font></font>
                        </h6>
                      </div>
                      <div class="reg-box submit-box">
                        <a class="yo-sub-but" href="javascript:;" id="submitInfo" @click="register"
                          ><font style="vertical-align: inherit"
                            ><font style="vertical-align: inherit">{{ $t('register.submit') }}</font></font
                          ></a
                        >
                        <p>
                          <font style="vertical-align: inherit"
                            ><font style="vertical-align: inherit">{{ $t('register.havean') }}</font></font
                          ><a class="yo-c-link" href="javascript:;"
                            ><font style="vertical-align: inherit" @click="$parent.goNav('/login')"
                              ><font style="vertical-align: inherit">{{ $t('header.Login') }}</font></font
                            ></a
                          >
                        </p>
                      </div>
                    </div>
                  </fieldset>
                </form>
              </div>
              <div class="yo-r-bot">
                <h6>
                  <font style="vertical-align: inherit"
                    ><font style="vertical-align: inherit">{{ $t('register.hint') }}</font></font
                  >
                </h6>
                <ol style="min-height: 111px">
                  <li>
                    <font style="vertical-align: inherit"
                      ><font style="vertical-align: inherit">{{ $t('register.bring') }}</font></font
                    ><span class="red-sign"
                      ><font style="vertical-align: inherit"><font style="vertical-align: inherit">*</font></font></span
                    ><font style="vertical-align: inherit"
                      ><font style="vertical-align: inherit">{{ $t('register.required') }}</font></font
                    >
                  </li>
                  <li>
                    <font style="vertical-align: inherit"
                      ><font style="vertical-align: inherit">{{ $t('register.proof') }}</font></font
                    >
                  </li>
                  <li>
                    <font style="vertical-align: inherit"
                      ><font style="vertical-align: inherit">{{ $t('register.other') }}</font></font
                    >
                  </li>
                </ol>
              </div>
            </div>
          </div>

          <!--协议弹框 begin-->
          <div id="UserAgree" class="yo-tc-body">
            <div class="yo-tc-yhxy">
              <div class="yo-t-title">
                <h1>
                  <font style="vertical-align: inherit"><font style="vertical-align: inherit">用户协议</font></font>
                </h1>
                <a class="yo-tc-cloes" href="javascript:;"
                  ><font style="vertical-align: inherit"><font style="vertical-align: inherit">关闭</font></font></a
                >
              </div>
              <div class="yo-t-center">
                <div class="yhxy-c-text">
                  <h2>
                    <font style="vertical-align: inherit"><font style="vertical-align: inherit">立即开通本公司游戏账户，享受最优惠的各项红利！</font></font>
                  </h2>
                  <ul>
                    <li>
                      <font style="vertical-align: inherit"><font style="vertical-align: inherit">本公司只接受已满 18 岁的客户申请，同时我们为客户提供其年龄证明的权利。</font></font>
                    </li>
                    <li>
                      <font style="vertical-align: inherit"><font style="vertical-align: inherit">在公司进行注册时所提供的全部信息必须准确无误，在使用借记卡或信用卡时，持卡人的姓名必须与在网站上注册时的一致。</font></font>
                    </li>
                    <li>
                      <font style="vertical-align: inherit"><font style="vertical-align: inherit">在开户后进行最大有效存款，即成为本公司永久有效会员！</font></font>
                    </li>
                    <li>
                      <font style="vertical-align: inherit"><font style="vertical-align: inherit">成为本站有效后，客户可随时通过电子邮件联系、联系在线客服、或在本公司站点上留言、客服等方式，随时向本公司提供最新的个人资料。</font></font>
                    </li>
                    <li>
                      本公司如发现个别会员有重复申请账号行为时，本公司有权将这些账户视为一个联合账户。本公司保留取消、收回会员所有优惠红利，以及优惠红利所产生的盈利之权利。本公司系统严格要求玩家、住址、电邮、电话号码、支付卡/信用卡均为唯一性，任何共享计算机环境
                      (例如:网吧、其他公共用计算机等)只能够拥有一个会员账号，各项优惠只适用于每位客户在本公司站点唯一的账户。
                    </li>
                    <li>本公司是提供互联网投注服务的机构。请会员在注册前参考当地政府的法律，在博彩不被允许的地区，如有会员在本公司注册、投注，均为会员个人行为，本公司不负责、承担任何相关联带责任。</li>
                    <li>无论是个人或是团体，如有任何威胁、滥用本公司优惠的行为，本公司将保留权利取消、收回由优惠产生的红利，并保留权利追讨最高50%手续费。</li>
                    <li>所有本公司游戏娱乐站点的优惠是特别为玩家而设，在玩家注册信息有争议时，为确保双方利益、杜绝身份盗用行为，本公司保留权利要求客户向我们提供充足有效的文件， 并以各种方式辨别客户是否符合资格享有我们的任何优惠。</li>
                    <li>客户一经注册开户，将被视为接受所有颁布在本以公司互联网投注网站上的规则与条例。</li>
                  </ul>
                </div>
              </div>
              <div class="yo-t-bot">
                <a href="javascript:;" class="yo-tc-cloes">我已届满合法博彩年龄，且同意各项开户条约。</a>
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'register',
  data() {
    return {
      index: 0,
      registerInfo: {},
      check_agree: true,
      imgLis: ['2PYL', '6AQ5', '8PHD', '21I7', '69HM', 'ACWA', 'DUZ7', 'IY98', 'K647', 'M52T', 'NY52', 'NZFA', 'SN76', 'SP4D', 'VAEO', 'YFQM', 'ZZU5', '7GQT', 'LFW3', 'NU2T', 'UAE3'],
      pid: '',
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    that.pid = localStorage.getItem('pid') || '';

    if (query.pid) {
      that.pid = query.pid;
    }
    that.changIndex();
  },
  methods: {
    changIndex() {
      this.index = parseInt(20 * Math.random());
    },
    register() {
      let that = this;

      if (!that.check_agree) {
        // {{$t('register.other')}}
        that.$parent.showTost(0, that.$t('register.read'));
        return;
      }

      let info = {};
      info.name = that.registerInfo.name || '';
      info.password = that.registerInfo.password || '';
      info.confirmPass = that.registerInfo.confirmPass || '';
      info.realname = that.registerInfo.realname || '';
      info.paypassword = that.registerInfo.paypassword || '';
      let code = that.registerInfo.code || '';
      // 用户名验证
      let namereg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/; //不得低于6位，以字母或数字组合！
      let passwordreg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/; //以字母或数字组合！不低于8位
      var realnamereg = /^[\u0391-\uFFE5a-zA-Z·&\\s]+$/; //中英文姓名
      let paypasswordreg = /^[0-9]{6}$/; //只能是6位
      let codereg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{4,}$/; //以字母或数字组合 不低于4位
      if (namereg.test(info.name) == false) {
        that.$parent.showTost(0, that.$t('register.Username'));
        return;
      }

      if (passwordreg.test(info.password) == false) {
        that.$parent.showTost(0, that.$t('register.Password'));
        return;
      }
      if (info.confirmPass != info.password) {
        that.$parent.showTost(0, that.$t('register.match'));
        return;
      }
      if (realnamereg.test(info.realname) == false) {
        that.$parent.showTost(0, that.$t('register.formatname'));
        return;
      }

      if (paypasswordreg.test(info.paypassword) == false) {
        that.$parent.showTost(0, that.$t('register.length'));
        return;
      }
      if (codereg.test(code) == false || code.toUpperCase() != that.imgLis[that.index]) {
        that.$parent.showTost(0, that.$t('register.codeerror'));
        that.registerInfo.code = '';
        that.changIndex();
        return;
      }

      that.$parent.showLoading();
      if (that.pid) {
        info.pid = that.pid;
      }
      that.$apiFun.register(info).then(res => {
        that.$parent.showTost(1, res.message);
        if (res.code == 200) {
          sessionStorage.setItem('token', res.data.api_token);
          that.$store.commit('changToken');
          that.getUserInfo();
          that.$parent.openDaoTime();
        }
        that.registerInfo.code = '';
        that.changIndex();
        that.$parent.hideLoading();
      })
       .catch(res => {
          that.$parent.hideLoading();
        });
      ;
    },
    getUserInfo() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
          that.$router.push({ path: '/' });
        }
        that.$parent.hideLoading();
      });
    },
  },
  mounted() {},
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/registermember.css';
@import '../../../static/css/verify.css';
@import '../../../static/css/gtstyle.css';
font {
  font-size: 12px;
}
.reg-box.yo-agreement span.joinus-label {
  display: flex;
}
.yo-register input {
  color: #333 !important;
}
.joinus-label {
  display: inline-block;
  width: 150px;
  padding-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/register.vue